import React, { useEffect } from 'react';
import { Icon } from '../../atoms';

const WEB_DASHBOARD_PATH = '/dashboard';
const PAYMENT_STATUS_PATH = '/payment-status';
const ANDROID_CUSTOM_SCHEME = 'nowomed://dashboard';

export const PaymentRedirect: React.FC = () => {
  const userAgent = navigator.userAgent ?? '';
  const isAndroid = /android/i.test(userAgent);

  const queryString = window.location.search;
  const webDashboardUrl = `${WEB_DASHBOARD_PATH}${queryString}`;
  const paymentStatusUrl = `${PAYMENT_STATUS_PATH}${queryString}`;
  const appUrl = `${ANDROID_CUSTOM_SCHEME}${queryString}`;

  useEffect(() => {
    if (isAndroid) {
      window.location.replace(appUrl);
    } else if (queryString.includes('payment_type=INVOICE') || queryString.includes('payment_type=PREPAYMENT')) {
      window.location.replace(paymentStatusUrl);
    } else {
      window.location.replace(webDashboardUrl);
    }
  }, [appUrl, isAndroid, webDashboardUrl]);

  return (
    <main className='flex flex-col items-center justify-center h-screen bg-gray-100 font-sans text-center p-6'>
      <div className='bg-white p-8 sm:p-12 rounded-2xl shadow-xl w-full max-w-lg'>
        <div className='mb-6'>
          <Icon icon='nowomed' size={200} />
        </div>
        <div>
          <div className='flex justify-center items-center mb-6'>
            <div className='animate-spin rounded-full h-16 w-16 border-b-2 border-green-500'></div>
          </div>
          <h1 className='text-2xl font-bold text-gray-800'>Ihre Zahlung wird verarbeitet...</h1>
          <p className='text-gray-500 mt-2'>Sie werden zur App weitergeleitet.</p>

          <div className='mt-6 text-sm text-gray-500'>
            Wird die App nicht geöffnet?{' '}
            <a href={isAndroid ? appUrl : webDashboardUrl} className='font-semibold text-blue-600 hover:underline'>
              Hier klicken
            </a>
          </div>
        </div>
      </div>
    </main>
  );
};
